var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container sign-up"},[_c('form',{staticClass:"sign-up-form"},[_c('validation-observer',[_c('div',{staticClass:"sign-up-form"},[_c('PageHeader',{attrs:{"contentHeader":_vm.emailVerificationSections}}),_c('PageSectionWithoutForm',{attrs:{"pageSection":_vm.pageSection},on:{"resend":_vm.resend_verification_email}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }